const translations = {
  inactivity: {
    info:
      "You will be automatically directed back to start page in {{seconds}} seconds...",
    toContinue: "Please touch the screen to continue with your process.",
  },
};

export {translations};
